function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.834,11.549H1c-0.552,0-1,0.448-1,1v66.236c0,0.552,0.448,1,1,1h5.834c0.552,0,1-0.448,1-1V12.549 C7.834,11.997,7.386,11.549,6.834,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.043,11.549h-4.168c-0.553,0-1,0.448-1,1v66.236c0,0.552,0.447,1,1,1h4.168c0.553,0,1-0.448,1-1V12.549 C63.043,11.997,62.596,11.549,62.043,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17,11.549h-4c-0.552,0-1,0.448-1,1v66.236c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V12.549 C18,11.997,17.552,11.549,17,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.334,11.549h-4c-0.552,0-1,0.448-1,1v66.236c0,0.552,0.448,1,1,1h4c0.553,0,1-0.448,1-1V12.549 C91.334,11.997,90.887,11.549,90.334,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.167,11.549h-2.724c-0.553,0-1,0.448-1,1v66.236c0,0.552,0.447,1,1,1h2.724c0.552,0,1-0.448,1-1V12.549 C82.167,11.997,81.719,11.549,81.167,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.875,11.549h-4c-0.553,0-1,0.448-1,1v66.236c0,0.552,0.447,1,1,1h4c0.552,0,1-0.448,1-1V12.549 C52.875,11.997,52.427,11.549,51.875,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.167,11.549h-2.5c-0.552,0-1,0.448-1,1v66.236c0,0.552,0.448,1,1,1h2.5c0.552,0,1-0.448,1-1V12.549 C43.167,11.997,42.719,11.549,42.167,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.523,11.549H71.98c-0.553,0-1,0.448-1,1v66.236c0,0.552,0.447,1,1,1h1.543c0.552,0,1-0.448,1-1V12.549 C74.523,11.997,74.076,11.549,73.523,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.667,11.549h-4c-0.552,0-1,0.448-1,1v66.236c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V12.549 C34.667,11.997,34.219,11.549,33.667,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.667,11.549h-1c-0.552,0-1,0.448-1,1v66.236c0,0.552,0.448,1,1,1h1c0.552,0,1-0.448,1-1V12.549 C24.667,11.997,24.219,11.549,23.667,11.549z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.227,11.549h-0.363c-0.551,0-1,0.448-1,1v66.236c0,0.552,0.449,1,1,1h0.363c0.551,0,1-0.448,1-1V12.549 C68.227,11.997,67.777,11.549,67.227,11.549z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgBusinesses = function SvgBusinesses(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "91.334px",
    height: "91.334px",
    viewBox: "0 0 91.334 91.334",
    style: {
      enableBackground: "new 0 0 91.334 91.334"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBusinesses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/businesses.7c79eb7e.svg";
export { ForwardRef as ReactComponent };